<style scoped>
  .post-footer {
    position: sticky;
    background-color:#f0f0f0;
    bottom: 63px;
    height: auto;
    width: 100%;
    /* left:0;
    right:0; */
    /* padding: 10px 10px 15px 15px; */
    display: flex;
  }
  .post-body {
    height: 100%;
    width: 100%;
    overflow-y: hidden;
    /* padding: 0 15px 75px 15px; */
  }
  .item-details {
    background-color: white;
    border-radius: 10px;
    margin: 5px 5px 0 10px;
    padding: 5px 0 5px 0;
    width: 100%;
  }
  .like {
    background-color:#faf9f9;
    bottom:-10px;
    box-shadow: 1px 2px #e0dede;
    border-radius:10px;
    font-size: 12px;
    height:17px;
    padding-left:4px;
    position:absolute;
    right:0px;
    width:32px;
  }
  .color-normal {
    color: #616772;
    /* font-weight: bold; */
  }
  .color-unlike {
    color: #2d8cf0;
    font-weight: bold;
  }
  .reply-header {
    /* border-color: #b4b0b0;
    border-width: 1px 0 0 0;
    border-style: solid; */
    justify-content:space-between;
    padding:5px 0 5px 0;
  }

</style>
<style>
  .o > .ivu-btn {
    padding: 0px !important;
  }
  .o > .ivu-input-wrapper > .ivu-input {
    /* border: 1px solid white !important; */
    border-color: white !important;
  }
  .o > .ivu-input-wrapper > .ivu-input:hover {
    border-color: white !important;
  }
  .o > .ivu-input-wrapper > .ivu-input:focus {
    border-color: white !important;
  }
</style>


<template>
  <div id="scrollableDiv" class="flex-container direction-col" v-if="feedItem">
    <p class="order-1" style="padding-left:15px;margin-bottom:5px;">
      <!-- <a @click="toggleComments()" v-if="commentCount==0">
        Comment
      </a>
      <a @click="toggleComments()" v-else-if="commentCount>0">
         Comments ({{ commentCount }})
        <Icon :type="(showComment) ? 'arrow-up-b': 'arrow-down-b'"></Icon>
      </a>     -->

      <!-- <div v-if="hasLike" class="direction-row center" style="position:absolute;top:0;right:0;margin-right:20px;width:auto;">
        <div v-if="showLike">
          <a v-if="isNotGuest && youveLikeIt() && !isLiking" @click="likeComment(activityIdLike,false)" class="color-unlike">Unlike</a>
          <a v-else-if="!youveLikeIt() && !isLiking" @click="likeComment(activityIdLike,true)" class="color-normal">Like</a>
          <a v-if="isNotGuest && youveLikeIt() && isLiking" class="color-unlike">Unliking...</a>
          <a v-else-if="isNotGuest && !youveLikeIt() && isLiking">Liking...</a>
        </div>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <a style="height:18px;line-height:18px" @click="showLikeModal=true">
            <img style="height: 16px;    margin-top: -2px;    width: 12px;    display: inline;    vertical-align: middle;" :src="likeSolidImg"/>
        </a>
        <p @click="showLikeModal=true">&nbsp; {{ activityLikesCount }}</p>
      </div> -->

    </p>

    <div v-show="showComment" class="order-2 direction-col post-body" :style="(showReplyTo) ? 'padding: 18px 15px 75px 15px;':'padding: 18px 15px 25px 15px;'">

      <Comments v-for="(activity,index) in activities"
        :type="'comment'"
        :item="activity"
        :index="index"
        :key="index">

        <!-- View Previous -->
        <div :id="'clickPrevious'+activity.id" v-if="activity.comment.comments.length>1" class="order-3" style="font-size:111px; padding-left:60px; margin-top:10px; font-size:10px;">
          <h3 @click="viewPrevious(activity.id)">View {{activity.comment.comments.length-1}} previous replies</h3>
        </div>

        <!-- Load Previous -->
        <div :id="'loadPrevious'+activity.id"  v-if="hasPaging" class="order-3 direction-row center" style="font-size:111px; padding-left:60px; margin-top:10px; font-size:10px;">
          <img style="height:15px;width:15px;" src="@/assets/refresh.png">
          <h4 style="color:black; margin-left:5px;">Load previous comments</h4>
        </div>

        <!-- Show the replies -->
        <div :id="'viewPrevious'+ activity.id" class="order-4" style="display:none;padding:10px 0 0px 0;">
          <Replies
            v-for="(reply, indexReply) in activity.comment.comments"
            :type="'reply'"
            :item="reply"
            :index="indexReply"
            :key="indexReply">
          </Replies>
        </div>

        <!-- show the only one reply -->
        <div class="order-4" style="padding:10px 0 0px 0;" v-if="activity.comment.comments.length==1"
          v-for="(latest, indexLatest) in latestComment(activity.comment.comments)" :key="indexLatest">
          <Replies
            :type="'reply'"
            :item="latest"
            :index="indexLatest"
            :key="indexLatest">
          </Replies>
        </div>

        <!-- Latest comment with different layout -->
        <div v-if="activity.comment.comments.length>1 && !showReplies" class="order-3" style="margin-top:5px; padding-left:60px;" v-for="(latest, indexLatest) in latestComment(activity.comment.comments)" :key="indexLatest">
          <Card :bordered="false" dis-hover :padding="0" style="background-color: transparent;">
            <div class="direction-row center" style="flex-wrap:wrap;">
              <div class="order-1 pointer"  @click="avatarClick(latest.user)">
                <Avatar size="small" :src="latest.user.avatar"></Avatar>
                <b class="order-2" style="color:black;font-size:12px;"> &nbsp; {{ latest.user.display_name }} </b>
              </div>
              <read-more class="order-3" style="font-size:12px !important; margin-left:5px;"
                more-str=""
                :text="latest.content"
                less-str=""
                :max-chars="28-latest.user.display_name.length">
              </read-more>
            </div>
          </Card>
        </div>

      </Comments>

    </div>

    <!-- footer -->
    <div id="footerComment" class="order-3 direction-col post-footer" style="z-index: 10;" :style="(showReplyTo) ? 'border-top:2px solid #d2cdcd':'border-top:0px solid #d2cdcd'" v-if="$store.state.user.info.user_type !== 'guest' && showComment">
        <div v-if="showReplyTo" class="direction-row center reply-header">
          <div class="direction-row center" style="margin-left:15px;">
            <img class="order-1" style="height:20px; width:20px;" src="@/assets/comment.png">
            <h5 class="order-2" style="margin-left:5px;">Replying to {{ replyToName }} . . .</h5>
          </div>
          <img @click="replyClickHide" style="margin-right:10px;height:25px; width:25px;" src="@/assets/close.png">
        </div>
        <div class="order-2 direction-row" style="width:100%; padding: 5px 10px 10px 15px;">
          <div class="order-1" style="align-self:flex-end">
            <Avatar size="large" :src="userDisplayImage(userInfo)"  style="margin-bottom:5px;" ></Avatar>
          </div>
          <div class="order-2 item-details center o">
            <div class="direction-row center o" style="background-color:white;width:100%;margin:0px;padding:0 5px 0 5px;border-radius:10px;font-size:10px !important; align-items:flex-end;">
              <Input id="reply" ref="reply" v-model="reply" type="textarea" :rows="1" :placeholder="placeHolderText" :autosize="{ maxRows: 5}" style="width: 100%;margin: 0 10px 0 0px;"></Input>
              <Button v-show="hasReply && !isReplying" @click="replyToId.length>0 ? postReply(): postComment()" type="text" ><Icon type="android-send" size="25"/> </Button>
              <Button v-show="!hasReply && !isReplying" type="text" disabled><Icon type="android-send" size="25"/> </Button>
              <Button v-show="hasReply && isReplying" type="text" loading disabled></Button>
            </div>
          </div>
        </div>
    </div>

    <ModalHolder m-top="30" :title="''" :is-show="showLikeModal" :mWidth="'90%'"
        :mHeight="'75vh'" :closable="false" @on-close="showLikeModal=false" className="post-update-modal">
      <template slot="mheader">
      </template>
      <template slot="mcontent">
        <LikeComponent :users="activityLikes"></LikeComponent>
      </template>
    </ModalHolder>

  </div>
</template>


<script>
import _ from "lodash";
import Utils from '@/utils.js';
import Comments from '@/components/PostComponent';
import Replies from '@/components/PostComponent';
import ModalHolder from '@/components/ModalHolderComponent';
import LikeComponent from '@/components/LikeComponent';
import likeSolidImg from '@/assets/svg/thumbs-up-solid.svg'
import { mapGetters } from 'vuex'
// import {scroller} from 'vue-scrollto/src/scrollTo';
// const firstScrollTo = scroller();


const methodsMixin = {
  methods: {
    likeComment(id, isLike) {
      if (this.$store.state.user.info && this.$store.state.user.info.user_type === 'guest') {
        this.$store.commit('hitCheckpoint')
        return false
      }

      var param = { id:id, isLike:isLike };
      this.isLiking = true;
      this.$store.dispatch("feed/likeActivity", param).then(
        res=>{
          if (!isLike) { // remove like from comment.
            var index = this.activityLikes.map(
              function(x) { return x.id; }
            ).indexOf(this.currentUserId);
            this.activityLikes.splice(index, 1);
          }
          this.isLiking=false;
        },
        error=>{
          this.isLiking=false;
        }
      );
    },
    eventEmitter: function() {
      BroadcastEvent.$on('onLike',(isLike) => {
        this.likeComment(this.activityIdLike,isLike);
      });
      BroadcastEvent.$on('onReplyClickShow',( {id,name}) => {
        this.replyClickShow(id,name);
      });
      BroadcastEvent.$on('onToggleComment', ()=> {
        if (!this.showComment) this.toggleComments();
        else { this.scrollBelow(); }
      });
      BroadcastEvent.$on('closeLikeModal', ()=> {
        this.showLikeModal=false;
      });
    },
    replyClickHide: function() {
      this.reply='';
      this.replyToId='';
      this.replyToName='';
      this.showReplyTo = false;
    },
    replyClickShow: function(id,name) {
      this.replyToId=id;
      this.replyToName=name;
      this.showReplyTo = true;

      let posY = this.findPos(document.getElementById(id));
      window.scroll(0,posY-390);

      this.focusWriteComment();
    },
    findPos: function(obj) {
      var curtop = 0;
      if (obj.offsetParent) {
          do {
              curtop += obj.offsetTop;
          } while (obj = obj.offsetParent);
      return [curtop];
      }
    },
    viewPrevious: function(id) {
      this.showReplies=true;
      document.getElementById("viewPrevious"+id).style["display"] = null;
      document.getElementById("clickPrevious"+id).style["display"]="none";
      this.scrollBelow();
    },
    focusWriteComment: function() {
      setTimeout(function() {
        // document.getElementById("reply").focus();
        // if (this.$refs.reply!==undefined)  {
        //   this.$refs.reply.focus();
        // }
      },0);
    },
    toggleComments: function() {
      if (this.$store.state.user.info && this.$store.state.user.info.user_type === 'guest') {
        this.$store.commit('hitCheckpoint')
        return false
      }

      this.showComment= !this.showComment;
      if (this.showComment)
      {
        setTimeout(function() {
          window.scrollTo(0, document.body.scrollHeight);
        },0);
      }
    },
    scrollBelow: function() {
      window.scrollTo(0, document.body.scrollHeight);
    },
    postReply() {
      if(!Utils.verifyUser()){
        this.$store.commit('user/showVerifyModal', true)
        return false
      }
      var param = { content: this.reply, item_id: this.replyToId };
      this.$store.dispatch("feed/postFeedSingleReply", param).then(
        res=> {
          this.replyClickHide();
          // DO THE POINTS
          this.$store.dispatch("points/setUserActionPoints", {
            action: "comment",
            element_id: this.replyToId
          }, {root: 1})

          // let pos = this.findPos(document.getElementById(res.data.id));
          // window.scroll(0,pos);
          // this.scrollTo(document.getElementById(res.id));
        }
      );
    },
    postComment() {
      if(!Utils.verifyUser()){
        this.$store.commit('user/showVerifyModal', true)
        return false
      }
      var param = { content: this.reply, item_id: this.$route.params.activityID };
      this.$store.dispatch("feed/postFeedSingleComment", param).then(
        res=> {
          this.reply="";
          // DO THE POINTS
          this.$store.dispatch("points/setUserActionPoints", {
            action: "comment",
            element_id: this.$route.params.activityID
          }, {root: 1})

          this.scrollBelow();
        }
      );
    },
    userDisplayImage(user) {
      return Utils.getDisplayImage('user', user, 'small')
    }

  }
}

export default {
  name: 'CommentsComponent',
  components: { Comments, Replies, ModalHolder, LikeComponent,likeSolidImg },
  mixins:[methodsMixin],
  props: {
    commentFocus: Boolean, required:false, default:false,
    feedItem: Object, required: true,
    showLike: Boolean,
    hasLike: Boolean
  },
  data() {
    return {
      isLiking: false,
      showLikeModal: false,
      showReplyTo: false,
      replyToId: '',
      replyToName: '',
      showReplies: false,
      showComment: false,
      reply: "",
      replies: "",
      hasReply: false,
      likeSolidImg
    }
  },
  mounted() {
    this.eventEmitter();
    this.$store.dispatch('feed/getFeedSingleItemActivities', this.$route.params.activityID).then(
      res=> {

      }
    );
  },
  destroyed() {
    BroadcastEvent.$off('onLike');
    // BroadcastEvent.$off('onReplyClickShow');
    // BroadcastEvent.$off('onToggleComment');
    // BroadcastEvent.$off('closeLikeModal');
  },
  watch: {
    "reply": function() {
      if (this.reply!=undefined) {
        this.hasReply = this.reply.trim().length>0;
      }
    }
  },
  methods: {
    avatarClick(v) {
      if (this.isBroadcast) {
        Message.warning("Unable to display user profile")
      }
      else {
       this.$store.commit("base/setShowProfileModal", true)
       this.$store.commit("base/setShowProfileInfo", v)
      }
    }
  },
  computed: {
    ...mapGetters("user", ["isBroadcast"]),
    activityIdLike: function() {
      return this.$store.state.feed.singleFeedView.activity_id;
    },
    youveLikeIt: function() {
      return function() {
        var likeFound = _.find(this.activityLikes,['id', this.currentUserId]);
        return likeFound!=undefined;
      }
    },
    isNotGuest: function() {
      return this.$store.state.user.info.user_type !== 'guest';
    },
    activityLikes: function() {
      return this.$store.state.feed.activityLikes.data.likes;
    },
    activityLikesCount: function() {
      return Utils.numFormatterToK(this.$store.state.feed.activityLikes.data.likes.length);
      // return Utils.numFormatterToK(this.feedItem.like_count);
    },
    placeHolderText: function() {
      return (this.replyToId.length>0) ? 'Write a reply':'Write a comment';
    },
    latestComment: function() {
      return function(list) {
        var comments = _.orderBy(list,['date_recorded'],['desc']);
        if (comments.length>=1) return [comments[0]];
        return comments;
      }
    },
    hasPaging: function() {
      let feed = this.$store.state.feed.feedSingleItemActivities;
      return (feed.next_link!=null || feed.prev_link!=null);
    },
    activities: {
      get() {
        var data= _.orderBy(this.$store.state.feed.feedSingleItemActivities.activities, 'created_at',true,'asc');
        return data;
      }
    },
    isReplying: {
      get() {
        return this.$store.state.feed.isReplying;
      }
    },
    commentCount: function() {
      let activities = this.$store.state.feed.feedSingleItemActivities.activities;
      let count = 0;
      if (activities) count = activities.length;
      return count;
    },
    userInfo: {
      get() {
        return this.$store.state.user.info;
      }
    },
    currentUserId: {
      get() {
        return this.$store.state.user.info.id;
      }
    }
  }

}

</script>
